import {utils, writeFile} from "xlsx";
import moment from "moment";
import statuses from "../../const/links";

// Buyurtmalar ro'yxatini Excel (.xlsx) faylga chiqaradi.
// Ikki varaq: "Buyurtmalar" (har bir buyurtma bir qator) va
// "Tovarlar" (har bir buyurtmadagi har bir tovar alohida qator) —
// ikkinchisi 1C'ga qo'lda kiritish uchun qulay.

const statusName = (value) =>
    (statuses.find((s) => s.value === value) || {}).name || value || "";

const fmtDate = (v) => (v ? moment(v).format("DD.MM.YYYY HH:mm") : "");

const num = (v) => (v === null || v === undefined || v === "" ? "" : Number(v));

const clientOf = (order) => {
    if (order.client) return {name: order.client.name, phone: order.client.phoneNumber, type: "1C"};
    if (order.cbClient) return {name: order.cbClient.name, phone: order.cbClient.phoneNumber, type: "CRM"};
    return {name: "", phone: "", type: ""};
};

const lineSum = (p) => Number(p.price || 0) * Number(p.amount || 0);

export const orderRows = (orders) =>
    orders.map((o) => {
        const c = clientOf(o);
        const products = o.products || [];
        const sum = products.reduce((s, p) => s + lineSum(p), 0);
        return {
            "№": o.id,
            "Sana": fmtDate(o.createdAt),
            "Agent": o.user ? o.user.name : "",
            "Mijoz": c.name,
            "Mijoz turi": c.type,
            "Telefon": c.phone || "",
            "Do'kon": o.shop ? o.shop.name : "",
            "Tovar turlari": products.length,
            "Summa": sum,
            "Chegirma": num(o.discount),
            "To'lov": num(o.amountPayment),
            "Naqd": num(o.amountCashPayment),
            "Karta": num(o.amountCardPayment),
            "O'tkazma": num(o.amountTransferPayment),
            "Yetkazib berish": o.isDelivery ? "Ha" : "Yo'q",
            "Manzil": o.address || "",
            "Yetkazish sanasi": fmtDate(o.probablyDeliveryDate),
            "Holat": statusName(o.status),
            "Izoh": o.description || "",
        };
    });

export const productRows = (orders) =>
    orders.flatMap((o) => {
        const c = clientOf(o);
        return (o.products || []).map((p) => ({
            "Buyurtma №": o.id,
            "Sana": fmtDate(o.createdAt),
            "Agent": o.user ? o.user.name : "",
            "Mijoz": c.name,
            "Tovar": p.name || (p.product ? p.product.name : ""),
            "Artikul": p.vendorCode || (p.product ? p.product.vendorCode : ""),
            "Miqdor": num(p.amount),
            "Narx": num(p.price),
            "Summa": lineSum(p),
            "Narx turi": p.priceType || "",
            "Holat": statusName(o.status),
        }));
    });

const widths = (rows) => {
    if (!rows.length) return [];
    return Object.keys(rows[0]).map((key) => {
        const longest = rows.reduce(
            (m, r) => Math.max(m, String(r[key] ?? "").length),
            key.length
        );
        return {wch: Math.min(Math.max(longest + 2, 6), 60)};
    });
};

export const exportOrdersToExcel = (orders, {from, to} = {}) => {
    const wb = utils.book_new();
    const summary = orderRows(orders);
    const lines = productRows(orders);

    const ws1 = utils.json_to_sheet(summary);
    ws1["!cols"] = widths(summary);
    utils.book_append_sheet(wb, ws1, "Buyurtmalar");

    const ws2 = utils.json_to_sheet(lines);
    ws2["!cols"] = widths(lines);
    utils.book_append_sheet(wb, ws2, "Tovarlar");

    const range = from && to ? `_${from}_${to}` : "";
    writeFile(wb, `buyurtmalar${range}.xlsx`);
};
